export function isValidCheck(inputValue) {
    if (inputValue !== undefined && inputValue !== null) {
        return true;
    } return false;
}